function updateStickyAtcPrice() {
    let c = discountValue,
        r = discountValue;
    totalPurchasePrice = purchaseMirrorPrice, currentCheckedInput = "";
    financePriceVariant ? Math.round(totalPurchasePrice / 36) : Math.round(totalPurchasePrice);
    const getCurrencySymbol = document.querySelector('.choose_current-price[data-type="full"]').textContent.replace(/[0-9.,\s]/g, '').trim();
    console.log(totalPurchasePrice, "totalPurchasePrice");
    console.log(purchaseMirrorPrice, "purchaseMirrorPrice");
    console.log(financePriceVariant, "financePriceVariant");
    [...purchasePriceElems].forEach(e => {
        e.textContent = getCurrencySymbol + Math.round(totalPurchasePrice)
    }), [...purchaseOldPriceElems].forEach(e => {
        console.log(c), e.textContent = getCurrencySymbol + Math.round(totalPurchasePrice + c)
    }), [...financePriceElems].forEach(e => {
        e.textContent = getCurrencySymbol + Math.round(totalPurchasePrice / 36) + '/mo'
    }), [...financeOldPriceElems].forEach(e => {
        e.textContent = getCurrencySymbol + Math.round((totalPurchasePrice + c) / 36) + '/mo'
    }), [...purchaseDiscountLabelElems].forEach(e => {
        e.textContent = "Save " + getCurrencySymbol + Math.round(r)
    })
}

// updateStickyAtcPrice();